import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => ({
  statusDropDown: {
    width: '80%',
  },
}));
